import React, {useState, useEffect} from "react";
import { Link, useLocation, useNavigate } from 'react-router-dom'
import {normalizeInput, normalizeDate, calculate_age} from '../functions';
import { Tooltip as ReactTooltip } from "react-tooltip";
import axios from "axios";
import {get_golfer_profile, updateGolferProfile} from '../../API/APICalls';
import {States} from '../../data/States'

export default function MembershipAddress() {

    const navigate = useNavigate();
   
    const location = useLocation();
   
    let golferData = [];

    if (!location.state) {
        navigate ("/");
    } 
        
        let contact_guid=location?.state?.contact_guid;
        let handicap_id=location?.state?.handicap_id;
    
   
    const [inputs, setInputs] = useState({firstname: '', lastname: '', phone: '', email: '', dob: '', sex: '', address: '', address2:  '', city: '', state:'', zip: '', contact: ''});
   
    const handleChange = ({ target: { name, value } }: { target: { name: string, value: string } }) => setInputs(inputs => ({ ...inputs, [name]: value }));
    
    const [validate, setValidate] = useState(false);
    const [isLoading, setIsLoading] = useState(true);
    const [alert, setAlert] = useState('alert alert-danger');
    const [message, setMessage] = useState('');

    const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        setIsLoading(true);
       
        console.log(inputs);

        // //make call to API for create or update golfer
        //  const response = await updateGolferProfile('', inputs);

        // if (response)
        // {
         
        //     console.log(response);
        //     setIsLoading(false);
        // }     

        setAlert('alert alert-success');
        setMessage("Your address has been successfulled updated!");
        
        setIsLoading(false);
      
      
      }

      
      const formatDob = (event:React.KeyboardEvent<HTMLInputElement>) => { 
          
        const result = normalizeDate(event.currentTarget.value)
      
       const age = calculate_age(result)
       setInputs({... inputs, "dob": result });
       console.log("AGE " + age); 
       if (age >= 13 && age <=100 && result.length >= 10) 
       {
          setValidate(false);
       } else {
          setValidate(true);
       }
               
    }

      const formatPhoneNumber = (event:React.KeyboardEvent<HTMLInputElement>) => { 
          
          const result = normalizeInput(event.currentTarget.value)
          setInputs({... inputs, "phone": result });
                  
      }

      const handleBlur = (event:React.ChangeEvent<HTMLInputElement>) => { 
        console.log("now checking email")
      }

      useEffect(() => {

        if (!location.state) {
            navigate ("/");
        } 
        

         setIsLoading(true);
         setAlert("");
         
         get_golfer_profile(contact_guid).then((response) => {

            golferData = JSON.parse(response || '').results[0].properties;
            console.log(golferData);
            setInputs({... inputs,  "firstname": golferData.firstname, "lastname": golferData.lastname, "phone": golferData.phone, "email": golferData.email, "dob": golferData.date_of_birth, "sex": golferData.gender, "contact": golferData.contact_guid, "address": golferData.address, "address2": golferData.street_address_2 || '', "city": golferData.city || '', "state": golferData.hs_state_code, "zip": golferData.zip});
            setIsLoading(false);
        })

     }, []);




     

    return(
      <div className="container page_container mb-5 pb-5">
      <div className="col-12 col-sm-8 col-md-12 col-lg-8 col-xl-12 col-xxl-12">
      <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 my-5 "><h1 className="fs-1 text-left">Billing Information</h1></div>
          

      <div className={alert} role="alert">
                {message}
                </div>

          
          <form onSubmit={handleSubmit} autoComplete='off'>    

                {isLoading ? 
          <div className="loaderWrapper">
            <div className="loader"></div>
          </div>
          : ''}       

         <div className="row col-sm-12 col-12 col-md-12 col-lg-12">       
          <div className="col-12 col-sm-10">
                      <label className="form-label">Street Address*</label>
                      <input type="text" className="form-control" id="address" name="address" placeholder="" autoFocus value={inputs.address || ''}  onChange={handleChange} required/>
                  </div>

                  <div className="col-sm-12 col-sm-12 col-12 col-md-12 col-lg-10 mt-4">
                      <label className="form-label">Address 2</label>
                      <input type="text" className="form-control" id="address2" name="address2" placeholder="" value={inputs.address2 || ''} onChange={handleChange} />  
                  </div>

                  <div className="col-sm-12 col-sm-12 col-12 col-md-12 col-lg-10 mt-4">
                      <label className="form-label">City*</label>
                      <input type="text" className="form-control" id="city" placeholder="" name="city" value={inputs.city || ''} onChange={handleChange} required/>
                      
                  </div>
                  
                      <div className="col-sm-6 col-sm-6 col-6 col-md-6 col-lg-5 mt-4">
                          <label className="form-label">State</label>
                          <select name="state" className="form-select" id="state" onChange={handleChange} value={inputs.state}>             
                                  <option value="">Please select state</option>
                                  {States.map((option, index) =>(
                                  <option value={option.value} key={index}>{option.label}</option>
                                  ))}
                              </select>                        
                      </div>

                      <div className="col-sm-6 col-6 col-md-6 col-lg-5 mt-4">
                              <label className="form-label">ZIP Code</label>
                              <input type="text" className="form-control" id="zipcode" placeholder="" name="zip" value={inputs.zip || ''} onChange={handleChange}/>
                              
                          </div>
                
                  </div>
                  
                      <div className="row mt-4 col-12 col-md-12 col-sm-12 col-lg-10">
                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 order-1 pt-3">
                              <Link to="/membership/dashboard"  state={{"contact_guid":contact_guid, "handicap_id": handicap_id}}  className="w-100 btn btn-outline-secondary btn-lg rounded-pill" type="button">
                                  BACK
                              </Link>
                          </div>
                          <div className="col-12 col-sm-6 col-md-6 col-lg-6 order-sm-1 order-lg-1 pt-3 ms-0">
                              <button className="btn btn-primary w-100 btn-lg rounded-pill" type="submit">
                                  CONTINUE
                              </button>
                          </div>
                      </div>
                      </form>
          
              
 </div>
 
</div>
    )
}